export default __webpack_public_path__ + "static/media/VO_SMILING_FEMALE.c23ccec2.png";